import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServerService } from "../app/server.service";

@Injectable({ providedIn: 'root' })
export class EncuestaAccessGuard implements CanActivate {
  constructor(private server: ServerService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const encuestaId = Number(route.paramMap.get('id'));
    if (!encuestaId || Number.isNaN(encuestaId)) {
      return of(this.router.parseUrl('/403'));
    }

    return this.server.getAccesosEncuestasLibres(encuestaId).pipe(
      map(r => {
        const visibilidad = r?.[0]?.visibilidad_libre;
        return visibilidad === 1
          ? true
          : this.router.parseUrl('/403');
      }),
      catchError(err => {
        console.log('❌ Error servidor:', err);
        return of(this.router.parseUrl('/403'));
      })
    );
      }
    }